/**
 * **Was im Browser wie oft benutzt wird** (15.10.2026,
 * [E-410](../../../../docs/ENTSCHEIDUNGEN.md#e-410)).
 *
 * Die Gegenstelle zu `apps/api/src/nutzung.ts`. Der Server zählt jeden Prozeduraufruf selbst;
 * hier kommt nur dazu, was er nicht sieht:
 *
 * - `seite:<route>` – jeder Wechsel der Ansicht, nach der **Route**, nicht nach dem Pfad
 *   (in einem Pfad kann eine Kennung stehen).
 * - `ansicht:<name>` – Umschalter innerhalb einer Seite, etwa die vier Modi von Mein Tag.
 * - `klick:<name>` – jedes Element mit `data-nutzung="<name>"`. Wer wissen will, ob ein Knopf
 *   gebraucht wird, schreibt das Attribut daran und liest nach ein paar Wochen nach.
 *
 * Ohne Person, ohne Inhalt: gesammelt wird eine Zahl je Schlüssel, geschickt alle fünf Minuten
 * und beim Verlassen der Seite.
 */

const SENDEN_ALLE_MS = 5 * 60_000
const NAME = /^[a-z0-9:/_.-]{1,100}$/i

let offen: Record<string, number> = {}

export function zaehlen(schluessel: string): void {
  if (!NAME.test(schluessel)) return
  offen[schluessel] = (offen[schluessel] ?? 0) + 1
}

function senden(): void {
  if (Object.keys(offen).length === 0) return
  const koerper = JSON.stringify(offen)
  offen = {}
  /** Als Zeichenkette: `text/plain` braucht keine Vorabfrage und kommt auch beim Schließen an. */
  if (typeof navigator.sendBeacon === 'function' && navigator.sendBeacon('/api/nutzung', koerper)) {
    return
  }
  void fetch('/api/nutzung', {
    method: 'POST',
    body: koerper,
    headers: { 'content-type': 'text/plain' },
    keepalive: true,
  }).catch(() => undefined)
}

interface Routenquelle {
  subscribe: (ereignis: 'onResolved', fn: () => void) => () => void
  state: { matches: { routeId: string }[] }
}

/** Einmal beim Start, aus `main.tsx` – Tests rufen es nicht, also zählt dort nichts. */
export function nutzungStarten(router: Routenquelle): void {
  const seiteZaehlen = () => {
    const route = router.state.matches.at(-1)?.routeId
    if (route) zaehlen(`seite:${route === '/' ? 'meintag' : route.replace(/^\//, '')}`)
  }
  seiteZaehlen()
  router.subscribe('onResolved', seiteZaehlen)

  document.addEventListener(
    'click',
    (e) => {
      const ziel = e.target instanceof Element ? e.target.closest('[data-nutzung]') : null
      const name = ziel?.getAttribute('data-nutzung')
      if (name) zaehlen(`klick:${name}`)
    },
    { capture: true, passive: true },
  )

  window.setInterval(senden, SENDEN_ALLE_MS)
  window.addEventListener('pagehide', senden)
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') senden()
  })
}
